/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_NoteInputs */

const en_mk_tb_example_note = /** @type {(inputs: Mk_Tb_Example_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passing tests, human acceptance and a recorded release are separate states. Recording a release does not deploy the project.`)
};

const id_mk_tb_example_note = /** @type {(inputs: Mk_Tb_Example_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes lulus, penerimaan manusia, dan catatan rilis merupakan status terpisah. Mencatat rilis tidak menjalankan deployment proyek.`)
};

/**
* | output |
* | --- |
* | "Passing tests, human acceptance and a recorded release are separate states. Recording a release does not deploy the project." |
*
* @param {Mk_Tb_Example_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_note = /** @type {((inputs?: Mk_Tb_Example_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_note(inputs)
	return en_mk_tb_example_note(inputs)
});